import { useMemo } from "react";
import { CopilotChat, CopilotChatSuggestion } from "@copilotkit/react-ui";
import { CustomUserMessage } from "./components/CustomUserMessage/CustomUserMessage";
import { string } from "yup";
import { FC } from "react";
import ChatComponent from "./SimpleNewChat";
import styles from "./ChatLayout.module.scss";

export interface ChatLayoutProps {
  placeholder: string;
  chatLayoutProps?: unknown;
  onStopGeneration: (val: any) => void
  onSubmitMessage: (val: any) => void
  suggestions?: CopilotChatSuggestion[] | undefined
  showSuggestions?: boolean;
}

export const ChatLayout : FC<ChatLayoutProps> = ({
  placeholder,
  onSubmitMessage,
  suggestions,
  showSuggestions = false,
                                                   onStopGeneration

}) => {

  const labels = useMemo(() => ({
    title: "AI Assistant",
    placeholder,
  }), []);

  return (
    <div className={styles.chatWrap}>
      <CopilotChat
        className={styles.chat}
        labels={labels}
        UserMessage={CustomUserMessage}
        onStopGeneration={onStopGeneration}
        hideStopButton
        onSubmitMessage={onSubmitMessage}
        suggestions={showSuggestions ? (suggestions ?? []) : []}
      />
    </div>
  );
};